module.exports = __webpack_public_path__ + "img/edge_divers_favoris.534a7b93.svg";